// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__b5BmL","desabilitar":"OptionSelect_desabilitar__qPOCg","focado":"OptionSelect_focado__fi36N","novo":"OptionSelect_novo__5sjNL"};